import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { IBillWriteoffDetail } from "../../../bill/BillTypes";
import { useWriteoffModel } from "./writeoffModel";
import { IAllotAccountWriteoffDetail } from "../../AccountTypes";


const columns: ColumnsType<IAllotAccountWriteoffDetail> = [
    // {
    //     align: "center",
    //     title: '分支',
    //     dataIndex: 'branch',
    // },
    {
        title: '核销单号',
        dataIndex: 'code',
    },
    {
        title: '核销账户',
        dataIndex: 'accountName',
    },
    {
        title: '账户编码',
        dataIndex: 'accountCode',
    },
    {
        align: "center",
        title: '核销金额',
        dataIndex: 'writeoffAmount',
    },
    {
        align: "center",
        title: '状态',
        dataIndex: 'status',
        render: (v) =>
            v === 0 ? '待申请'
                : v === 1 ? '待对方确认'
                    : v === 2 ? '对方不认可'
                        : v === 3 ? '待财务确认'
                            : v === 4 ? '对方已驳回'
                                : v === 5 ? '待财务审核'
                                    : v === 6 ? '财务已驳回'
                                        : v === 7 ? '待最终审核'
                                            : v === 8 ? '最终审核通过'
                                                : v === 9 ? '最终已驳回'
                                                    : ''
    },
    {
        align: "center",
        title: '核销单位',
        dataIndex: 'uniName',
    },
    {
        align: "center",
        title: '核销实体',
        dataIndex: 'beName',
    },
    {
        align: "center",
        title: '对方单位',
        dataIndex: 'adverseUnitName',
    },
    {
        align: "center",
        title: '对方账户',
        dataIndex: 'adverseName',
    },
    {
        align: "center",
        title: '对方实体',
        dataIndex: 'adverseBeName',
    },
    {
        align: "center",
        title: '申请人',
        dataIndex: 'applyUser',
    },
    {
        align: "center",
        title: '申请时间',
        dataIndex: 'applyTime',
    },
    {
        align: "center",
        title: '申请说明',
        dataIndex: 'note',
    },
    {
        align: "center",
        title: '对方确认人',
        dataIndex: 'adverseAffirmUser',
    },
    {
        align: "center",
        title: '对方确认时间',
        dataIndex: 'adverseAffirmTime',
    },
    {
        align: "center",
        title: '财务确认人',
        dataIndex: 'financeAffirmUser',
    },
    {
        align: "center",
        title: '财务确认时间',
        dataIndex: 'financeAffirmTime',
    },
    {
        align: "center",
        title: '财务审核人',
        dataIndex: 'financeAuditUser',
    },
    {
        align: "center",
        title: '财务审核时间',
        dataIndex: 'financeAuditTime',
    },
    {
        align: "center",
        title: '最终审核人',
        dataIndex: 'endAuditUser',
    },
    {
        align: "center",
        title: '最终审核时间',
        dataIndex: 'endAuditTime',
    },

];

export function WriteoffDataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useWriteoffModel();


    return (
        <Table
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IAllotAccountWriteoffDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.key]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content' }}
        />
    )
}
